import { colors } from '../styles/colors';

export const initColors = () => {
  const root = document.documentElement;

  // Основные цвета
  root.style.setProperty('--color-primary', colors.primary.main); // #ff68b4
  root.style.setProperty('--color-primary-light', colors.primary.light); // #fff0f4
  root.style.setProperty('--color-primary-lighter', colors.primary.lighter); // #ffc0cb
  root.style.setProperty('--color-disabled', colors.primary.disabled); // #cccccc

  // Синие цвета
  root.style.setProperty('--color-blue', colors.blue.main); // #0095f6
  root.style.setProperty('--color-blue-dark', colors.blue.dark); // #00376b
  root.style.setProperty('--color-blue-light', colors.blue.light); // #b2dffc
  root.style.setProperty('--color-blue-verified', colors.blue.verified); // #0095f6

  // Текст
  root.style.setProperty('--color-text-primary', colors.text.primary); // #262626
  root.style.setProperty('--color-text-secondary', colors.text.secondary); // #8e8e8e
  root.style.setProperty('--color-text-light', colors.text.light); // #ffffff
  root.style.setProperty('--color-text-gray', colors.text.gray); // #666

  // Фон
  root.style.setProperty('--color-background-main', colors.background.main); // #ffffff

  // Границы
  root.style.setProperty('--color-border', colors.border.main); // #dbdbdb

  // Серые цвета
  root.style.setProperty('--color-gray', colors.gray.main); // #8e8e8e

  // Тени
  root.style.setProperty('--shadow-light', '0 1px 2px rgba(0, 0, 0, 0.1)');
  root.style.setProperty('--shadow-medium', '0 4px 15px rgba(0, 0, 0, 0.1)');
  root.style.setProperty('--shadow-dark', '0 6px 20px rgba(0, 0, 0, 0.15)');
  root.style.setProperty('--shadow-blue', '0 0 5px rgba(0, 149, 246, 0.5)');
  root.style.setProperty(
    '--shadow-blue-dark',
    '0 0 20px rgba(0, 149, 246, 0.8)'
  );

  // Состояния
  root.style.setProperty('--transparent-white', 'rgba(255, 255, 255, 0.5)');
  root.style.setProperty('--transparent-black', 'rgba(0, 0, 0, 0.5)');
};
